const EMPLEADO_HARDCODED_YPF = [
  {
    idEmpleado: 1,
    token: null,
    caldenON: 0,
    imaMobile: 0,
    salesman_PermiteModificarPrecio: false,
    idGrupoVendedores: null,
    legajo: 100,
    nombreEmpleado: "AONIKEN",
    esVendedor: true,
    password: "TP9AESAAX5DDZOR0XFGIL73N528=",
    autorizaDespachoManual: true,
  },
];

const getEmpleado = async () => {
  return {
    data: EMPLEADO_HARDCODED_YPF,
  };
};

const empleado = {
  getEmpleado,
};

export default empleado;
